var path = 'event/event-header-lc-event.tpl.html';
var html = "\n<div translate class=\"tb-cell\" flex=\"30\">event.event-time</div>\n<div translate class=\"tb-cell\" flex=\"20\">event.server</div>\n<div translate class=\"tb-cell\" flex=\"20\">event.event</div>\n<div translate class=\"tb-cell\" flex=\"20\">event.status</div>\n<div translate class=\"tb-cell\" flex=\"20\">event.error</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/event/event-header-lc-event.tpl.html
// module id = 1482
// module chunks = 1